import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import ScrollToTop from './Components/Common/ScrollToTop';
import Home from './Components/Common/Home';
import CommonLayout from './Components/Layout/CommonLayout';
import Login from './Feature/Login/Login';
import Contractor from './Components/Admin/Contractor';
import Visits from './Components/Admin/Visits';
import ManageRoles from './Components/Admin/ManageRoles';
import Distribution from './Components/Admin/Distribution';
import ZonalContractorReport from './Components/ZonalOfficer/ZonalContractorReport';
import ZonalDistribution from './Components/ZonalOfficer/ZonalDistribution';
import ZonalDistributionHistory from './Components/ZonalOfficer/ZonalDistributionHistory';
import BillAnalysis from './Components/Admin/BillAnalysis';
import TargetReport from './Components/ZonalOfficer/TargetReport';
import ZoneWiseConReport from './Components/Admin/ZoneWiseConReport';
import CallSummary from './Components/Admin/CallSummary';
import CallLog from './Components/Admin/CallLog';
import CallLogReport from './Components/Admin/CallLogReport';
import JaptiKarvai from './Components/Admin/JaptiKarvai';
import JaptiNotice from './Components/Admin/JaptiNotice';
import JaptiMukti from './Components/Admin/JaptiMukti';
import ContactRecords from './Components/Admin/ContactRecords';
import InternalDev from './Components/InternalDev/InternalDev';

import PageNotFound from './Components/Common/PageNotFound';
import { useSelector } from 'react-redux';
import JaptiKarvaiZoneReport from './Components/Admin/JaptiKarvaiZoneReport';
import DialedCallLog from './Components/Admin/DialedCallLog';
import DialedCallLogReport from './Components/Admin/DialedCallLogReport';
import TotalCalling from './Components/Admin/TotalCalling';
import ZOCallSummary from './Components/ZonalOfficer/ZoCallSummary';
import ZoHome from './Components/ZonalOfficer/ZoHome';
import ZoJaptiNotice from './Components/ZonalOfficer/ZoJaptiNotice';
import SmsSentReport from './Components/Admin/SmsSentReport';
import SmsDetails from './Components/Admin/SmsDetails';
import BillDistribution from './Components/Common/BillDistribution';
import ZoCallLog from './Components/ZonalOfficer/ZoCallLog';
import ZoDialedCallLog from './Components/ZonalOfficer/ZoDialedCallLog';
import ZoTotalCalling from './Components/ZonalOfficer/ZoTotalCalling';
import ZoCallSummary from './Components/ZonalOfficer/ZoCallSummary';
import ZoJaptiKarvai from './Components/ZonalOfficer/ZoJaptiKarvai';
import ZoJaptiMukti from './Components/ZonalOfficer/ZoJaptiMukti';
import PropertyCalling from './Components/Caller/PropertyCalling';
import NewHome from './Components/NewDashboard/NewHome'
import NewContractor from './Components/NewDashboard/NewContractor';
import NewVisitReport from './Components/NewDashboard/NewVisitReport';
import ViewVisitReport from './Components/NewDashboard/ViewVisitReport';
import DeleteUsers from './Components/Common/DeleteUsers';
import BillReports from './Components/NewDashboard/BillReports';
import DeleteBillHistory from './Components/NewDashboard/DeleteBillHistory';
import ViewDeletedReport from './Components/NewDashboard/ViewDeletedReport';
import PrivacyPolicy from './Components/Common/PrivacyPolicy';
import NewBillAnalysis from './Components/NewDashboard/NewBillAnalysis';
import ViewContractorReport from './Components/NewDashboard/ViewContractorReport';
import NewJaptiNotice from './Components/NewDashboard/NewJaptiNotice';
import RejectedFormList from './Components/NewDashboard/RejectedFormList';
import NewGatWiseBillAnalysis from './Components/NewDashboard/NewGatWiseBillAnalysis';
import Analytics from './Components/Admin/Analytics';
import ViewFullScreen from './Components/Common/ViewFullScreen';
import InternalDevNew from './Components/InternalDev/InternalDevNew';
import TelecallingDefaulter from './Components/InternalDev/TelecallingDefaulter';
import Verification from './Components/Admin/ImageVerification/Verification';
import Rejected from './Components/Admin/ImageVerification/Rejected';
import SurveyVerification from './Components/Admin/SurveyVerification/SurveyVerification';
import SurveyRejectedList from './Components/Admin/SurveyVerification/SurveyRejectedList';
import SurvetVerificationView from './Components/Admin/SurveyVerification/SurveyVerificationView';
import SurveyRejectedViewList from './Components/Admin/SurveyVerification/SurveyRejecetdViewList';
import GatBillDistribution from './Components/GatLipik/GatBillDistribution';
import GatPropertyVisitReport from './Components/GatLipik/GatPropertVisitReport';
import GatPropertVisitReportView from './Components/GatLipik/GatPropertyVisitReportView';
import GatMahilaWiseReport from './Components/GatLipik/GatMahilaWiseReport';
import GatMahilaWiseReportView from './Components/GatLipik/GatMahilaWiseReportView';
import GatMahilaWiseVisitReportView from './Components/GatLipik/GatMahilaWiseVisitReportView';
import GatWiseBillAnalysis from './Components/GatLipik/GatWiseBillAnalysis';
import GatJaptiNotice from './Components/GatLipik/GatJaptiNotice';
import GatBillReport from './Components/GatLipik/GatBillReport';
import GatBillReportView from './Components/GatLipik/GatBillReportView';
import GatDeleteBillHistory from './Components/GatLipik/GatDeleteBillHistory';
import GarDeleteBillHistoryView from './Components/GatLipik/GatDeleteBillHistoryView';
import GatLipikReportAnalysis from './Components/GatLipik/GatLipikReportAnalysis';
import StaffVisitReport from './Components/Admin/StaffVisitReport';
import StaffVisitReportView from './Components/Admin/StaffVisitReportView';
import GatCallSummary from './Components/GatLipik/Telecalling/GatCallSummary';
import GatCallLog from './Components/GatLipik/Telecalling/GatCallLog';
import GatDialedCallLog from './Components/GatLipik/Telecalling/GatDialedCallLog';
import GatTotalCalling from './Components/GatLipik/Telecalling/GatTotalCalling';
import PalikaUsers from './Components/NewDashboard/PalikaUsers';
import GatJaptiKarvai from './Components/GatLipik/GatJaptiKarwai';
import GatJaptiMukti from './Components/GatLipik/GatJaptimukti';
import NewPropertyFound from './Components/NewDashboard/NewPropertyFound';
import NewPropertyView from './Components/NewDashboard/NewPropertyView';


function App() {

  const userState = useSelector(state => state?.loginData?.userData);


  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/delete/users' element={<DeleteUsers />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/view-fullscreen' element={<ViewFullScreen />} />
          {
            userState?.usertype_keyname?.includes("caller") &&
            <Route path="/property-calling" element={<PropertyCalling />} />
          }

          {userState?.usertype_keyname?.[0] === "admin" || userState?.usertype_keyname?.[0] === "internalDev" ?
            <Route path='/dashboard' element={<CommonLayout />}>
              <Route path='/dashboard' element={<Home />} />
              <Route path='/dashboard/analytics' element={<Analytics />} />
              <Route path='/dashboard/bill-distribution' element={<BillDistribution />} />
              <Route path='/dashboard/manage-roles' element={<ManageRoles />} />
              <Route path='/dashboard/contractors' element={<Contractor />} />
              <Route path='/dashboard/visits' element={<Visits />} />
              <Route path='/dashboard/distribution' element={<Distribution />} />
              <Route path='/dashboard/zonewise-bill-analysis' element={<BillAnalysis />} />

              <Route path='/dashboard/call-summary' element={<CallSummary />} />
              <Route path='/dashboard/call-logs' element={<CallLog />} />
              <Route path='/dashboard/call-log-report' element={<CallLogReport />} />
              <Route path='/dashboard/update-mobile' element={<ContactRecords />} />
              <Route path='/dashboard/dialed-call-logs' element={<DialedCallLog />} />
              <Route path='/dashboard/dialed-call-log-report' element={<DialedCallLogReport />} />
              <Route path='/dashboard/japti-karvai' element={<JaptiKarvai />} />
              <Route path='/dashboard/japti-notice' element={<JaptiNotice />} />
              <Route path='/dashboard/japti-mukti' element={<JaptiMukti />} />
              <Route path='/dashboard/japti-karvai-zone-report' element={<JaptiKarvaiZoneReport />} />
              <Route path='/dashboard/total-calling' element={<TotalCalling />} />
              <Route path='/dashboard/sms-sent-report' element={<SmsSentReport />} />
              <Route path='/dashboard/sms-details' element={<SmsDetails />} />

              {userState?.usertype_keyname?.[0] === "internalDev" &&
                <>
                  <Route path='/dashboard/internal-dev' element={<InternalDev />} />
                  <Route path='/dashboard/export-call-logs' element={<InternalDevNew />} />
                  <Route path='/dashboard/telecalling-defaulter' element={<TelecallingDefaulter />} />
                </>

              }

              {userState?.usertype_keyname?.[0] === "admin" &&
                <>
                  <Route path='/dashboard/imageverification' element={<Verification />} />
                  <Route path='/dashboard/rejected' element={<Rejected />} />
                  <Route path='/dashboard/surveyverification' element={<SurveyVerification />} />
                  <Route path='/dashboard/surveyverificationView' element={<SurvetVerificationView />} />
                  <Route path='/dashboard/surveyrejected' element={<SurveyRejectedList />} />
                  <Route path='/dashboard/survey-rejected-view-list' element={<SurveyRejectedViewList />} />
                  <Route path='/dashboard/staff-visit-reports' element={<StaffVisitReport />} />
                  <Route path='/dashboard/staff-visit-reports-view' element={<StaffVisitReportView />} />
                </>

              }

              <Route path='/dashboard/new-home' element={<NewHome />} />
              <Route path='/dashboard/new-contractors' element={<NewContractor />} />
              <Route path='/dashboard/palika-users' element={<PalikaUsers />} />
              <Route path='/dashboard/new-visit-reports' element={<NewVisitReport />} />
              <Route path='/dashboard/view-visit-report' element={<ViewVisitReport />} />
              <Route path='/dashboard/view-contractor-report' element={<ViewContractorReport />} />
              <Route path='/dashboard/bill-report' element={<BillReports />} />
              <Route path='/dashboard/deleted-bill-history' element={<DeleteBillHistory />} />
              <Route path='/dashboard/view-delete-report' element={<ViewDeletedReport />} />
              <Route path='/dashboard/new-bill-analysis' element={<NewBillAnalysis />} />
              <Route path='/dashboard/new-japti-notice' element={<NewJaptiNotice />} />
              <Route path='/dashboard/rejected-list' element={<RejectedFormList />} />
              <Route path='/dashboard/gatwise-bill-analysis' element={<NewGatWiseBillAnalysis />} />
              <Route path='/dashboard/new-property-found' element={<NewPropertyFound />} />
              <Route path='/dashboard/new-property-view' element={<NewPropertyView />} />

            </Route>
            : ''
          }

          {
            userState?.usertype_keyname?.[0] === "zonalofficer" &&
            <Route path='/dashboard' element={<CommonLayout />}>
              <Route path='/dashboard' element={<ZoHome />} />
              <Route path='/dashboard/zonewise-bill-analysis' element={<BillAnalysis />} />
              <Route path='/dashboard/bill-distribution' element={<BillDistribution />} />
              <Route path='/dashboard/contractors' element={<Contractor />} />
              <Route path='/dashboard/zonal-contractors' element={<ZonalContractorReport />} />
              <Route path='/dashboard/zonal-distribution' element={<ZonalDistribution />} />
              <Route path='/dashboard/zonal-distribution-history' element={<ZonalDistributionHistory />} />
              <Route path='/dashboard/zonal-target' element={<TargetReport />} />
              <Route path='/dashboard/zonal-contractor-report' element={<ZoneWiseConReport />} />
              <Route path='/dashboard/zonal-japti-notice' element={<ZoJaptiNotice />} />
              <Route path='/dashboard/imageverification' element={<Verification />} />
              <Route path='/dashboard/rejected' element={<Rejected />} />
              <Route path='/dashboard/surveyverification' element={<SurveyVerification />} />
              <Route path='/dashboard/surveyverificationView' element={<SurvetVerificationView />} />
              <Route path='/dashboard/surveyrejected' element={<SurveyRejectedList />} />
              <Route path='/dashboard/survey-rejected-view-list' element={<SurveyRejectedViewList />} />
              <Route path='/dashboard/staff-visit-reports' element={<StaffVisitReport />} />
              <Route path='/dashboard/staff-visit-reports-view' element={<StaffVisitReportView />} />

              {/* manage telecalling */}
              <Route path='/dashboard/zonal-call-summary' element={<ZoCallSummary />} />
              <Route path='/dashboard/zonal-call-logs' element={<ZoCallLog />} />
              <Route path='/dashboard/call-log-report' element={<CallLogReport />} />
              <Route path='/dashboard/zonal-dialed-call-logs' element={<ZoDialedCallLog />} />
              <Route path='/dashboard/dialed-call-log-report' element={<DialedCallLogReport />} />
              <Route path='/dashboard/zonal-total-calling' element={<ZoTotalCalling />} />

              {/* japti details */}
              <Route path='/dashboard/zonal-japti-notice' element={<ZoJaptiNotice />} />
              <Route path='/dashboard/zonal-japti-karvai' element={<ZoJaptiKarvai />} />
              <Route path='/dashboard/zonal-japti-mukti' element={<ZoJaptiMukti />} />

              <Route path='/dashboard/new-home' element={<NewHome />} />
              <Route path='/dashboard/manage-roles' element={<ManageRoles />} />
              <Route path='/dashboard/new-contractors' element={<NewContractor />} />
              <Route path='/dashboard/palika-users' element={<PalikaUsers />} />
              <Route path='/dashboard/view-contractor-report' element={<ViewContractorReport />} />
              <Route path='/dashboard/new-visit-reports' element={<NewVisitReport />} />
              <Route path='/dashboard/view-visit-report' element={<ViewVisitReport />} />
              <Route path='/dashboard/bill-report' element={<BillReports />} />
              <Route path='/dashboard/deleted-bill-history' element={<DeleteBillHistory />} />
              <Route path='/dashboard/view-delete-report' element={<ViewDeletedReport />} />
              <Route path='/dashboard/new-japti-notice' element={<NewJaptiNotice />} />
              <Route path='/dashboard/new-bill-analysis' element={<NewBillAnalysis />} />
              <Route path='/dashboard/gatwise-bill-analysis' element={<NewGatWiseBillAnalysis />} />

              <Route path='/dashboard/gatlipik-report-analysis' element={<GatLipikReportAnalysis />} />
            </Route>
          }

          {
            userState?.usertype_keyname?.[0] === "gatlipik" &&
            <Route path='/dashboard' element={<CommonLayout />}>
              <Route path='/dashboard' element={<ZoHome />} />
              <Route path='/dashboard/zonewise-bill-analysis' element={<BillAnalysis />} />
              <Route path='/dashboard/bill-distribution' element={<BillDistribution />} />
              <Route path='/dashboard/contractors' element={<Contractor />} />
              <Route path='/dashboard/new-gat-home' element={<GatBillDistribution />} />
              <Route path='/dashboard/gat-property-report' element={<GatPropertyVisitReport />} />
              <Route path='/dashboard/gat-view-property-report' element={<GatPropertVisitReportView />} />
              <Route path='/dashboard/gat-mahila-report' element={<GatMahilaWiseReport />} />
              <Route path='/dashboard/gat-mahila-report-view' element={<GatMahilaWiseReportView />} />
              <Route path='/dashboard/gat-mahila-visit-report' element={<GatMahilaWiseVisitReportView />} />
              <Route path='/dashboard/gat-wise-bill-analysis' element={<GatWiseBillAnalysis />} />
              <Route path='/dashboard/gat-japti-notice' element={<GatJaptiNotice />} />
              <Route path='/dashboard/gat-japti-karwai' element={<GatJaptiKarvai />} />
              <Route path='/dashboard/gat-japti-mukti' element={<GatJaptiMukti />} />
              <Route path='/dashboard/gat-bill-report' element={<GatBillReport />} />
              <Route path='/dashboard/gat-bill-report-view' element={<GatBillReportView />} />
              <Route path='/dashboard/gat-deleted-bill-history' element={<GatDeleteBillHistory />} />
              <Route path='/dashboard/gat-delete-bill-history-view' element={<GarDeleteBillHistoryView />} />
              <Route path='/dashboard/imageverification' element={<Verification />} />
              <Route path='/dashboard/rejected' element={<Rejected />} />
              <Route path='/dashboard/surveyverification' element={<SurveyVerification />} />
              <Route path='/dashboard/surveyverificationView' element={<SurvetVerificationView />} />
              <Route path='/dashboard/surveyrejected' element={<SurveyRejectedList />} />
              <Route path='/dashboard/survey-rejected-view-list' element={<SurveyRejectedViewList />} />
              <Route path='/dashboard/palika-users' element={<PalikaUsers />} />
              <Route path='/dashboard/view-contractor-report' element={<ViewContractorReport />} />
               <Route path='/dashboard/view-visit-report' element={<ViewVisitReport />} />

              {/* manage telecalling */}
              <Route path='/dashboard/gat-call-summary' element={<GatCallSummary />} />
              <Route path='/dashboard/gat-call-logs' element={<GatCallLog />} />
              <Route path='/dashboard/call-log-report' element={<CallLogReport />} />
              <Route path='/dashboard/gat-dialed-call-logs' element={<GatDialedCallLog />} />
              <Route path='/dashboard/dialed-call-log-report' element={<DialedCallLogReport />} />
              <Route path='/dashboard/gat-total-calling' element={<GatTotalCalling />} />
            </Route>

          }

          {
            userState?.usertype_keyname?.[0] === "supervisor" &&
            <Route path='/dashboard' element={<CommonLayout />}>
              <Route path='/dashboard/new-home' element={<NewHome />} />
              <Route path='/dashboard/manage-roles' element={<ManageRoles />} />
            </Route>
          }

          {
            userState?.usertype_keyname?.[0] === "mavim" ?
              <Route path='/dashboard' element={<CommonLayout />}>
                <Route path='/dashboard/new-home' element={<NewHome />} />
                <Route path='/dashboard/zonewise-bill-analysis' element={<BillAnalysis />} />
                <Route path='/dashboard/bill-distribution' element={<BillDistribution />} />
                <Route path='/dashboard/contractors' element={<Contractor />} />
                <Route path='/dashboard/manage-roles' element={<ManageRoles />} />
                <Route path='/dashboard/new-contractors' element={<NewContractor />} />
                <Route path='/dashboard/new-visit-reports' element={<NewVisitReport />} />
                <Route path='/dashboard/view-visit-report' element={<ViewVisitReport />} />
                <Route path='/dashboard/bill-report' element={<BillReports />} />
                <Route path='/dashboard/deleted-bill-history' element={<DeleteBillHistory />} />
                <Route path='/dashboard/view-delete-report' element={<ViewDeletedReport />} />
                <Route path='/dashboard/view-contractor-report' element={<ViewContractorReport />} />
                <Route path='/dashboard/new-japti-notice' element={<NewJaptiNotice />} />
                <Route path='/dashboard/rejected-list' element={<RejectedFormList />} />
                <Route path='/dashboard/new-bill-analysis' element={<NewBillAnalysis />} />
              </Route>
              : ''
          }

           {
            userState?.usertype_keyname?.[0] === "sakshama" ?
              <Route path='/dashboard' element={<CommonLayout />}>
                <Route path='/dashboard/new-home' element={<NewHome />} />
                <Route path='/dashboard/zonewise-bill-analysis' element={<BillAnalysis />} />
                <Route path='/dashboard/bill-distribution' element={<BillDistribution />} />
                <Route path='/dashboard/contractors' element={<Contractor />} />
                <Route path='/dashboard/manage-roles' element={<ManageRoles />} />
                <Route path='/dashboard/new-contractors' element={<NewContractor />} />
                <Route path='/dashboard/new-visit-reports' element={<NewVisitReport />} />
                <Route path='/dashboard/view-visit-report' element={<ViewVisitReport />} />
                <Route path='/dashboard/bill-report' element={<BillReports />} />
                <Route path='/dashboard/deleted-bill-history' element={<DeleteBillHistory />} />
                <Route path='/dashboard/view-delete-report' element={<ViewDeletedReport />} />
                <Route path='/dashboard/view-contractor-report' element={<ViewContractorReport />} />
                <Route path='/dashboard/new-japti-notice' element={<NewJaptiNotice />} />
                <Route path='/dashboard/rejected-list' element={<RejectedFormList />} />
                <Route path='/dashboard/new-bill-analysis' element={<NewBillAnalysis />} />
              </Route>
              : ''
          }


          <Route path='*' element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
